import { Typography } from "@mui/material";
import { Box, SxProps } from "@mui/system";
import ContactText from "../components/ContactText";

interface UnexpectedErrorProps {
    description?: string;
}

const boxSx: SxProps = {
    display: "flex",
    flexDirection: "column",
    flex: 1,
};

const DEFAULT_DESCRIPTION = "An unexpected error has occurred.";

export default function UnexpectedError({ description = DEFAULT_DESCRIPTION }: UnexpectedErrorProps) {
    return (
        <>
            <Box sx={boxSx}>
                <Typography variant="h1" gutterBottom color="error.main">
                    Oops!
                </Typography>

                <Typography variant="h5" gutterBottom>
                    {description}
                </Typography>

                <Typography gutterBottom>
                    This is quite the embarrassment, but it looks like you&apos;ve found a bug. If you can, please let us
                    know what happened before you got this message, so that we can go squash that bug and fix it.
                </Typography>

                <Typography gutterBottom>
                    <ContactText />
                </Typography>
            </Box>
        </>
    );
}
